import { render, staticRenderFns } from "./CtrlTipoServicoPage.vue?vue&type=template&id=66d2ad1c"
import script from "./CtrlTipoServicoPage.vue?vue&type=script&lang=js"
export * from "./CtrlTipoServicoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports